// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SearchUI__SearchUI___27zk2,.SearchUI__SearchUIDarkTheme___uyV0K{display:flex;flex-direction:column;margin-right:0}.SearchUI__SearchUIDarkTheme___uyV0K{background-color:#323232!important}.SearchUI__SearchUIDocked___3jLXq{width:100%}", ""]);
// Exports
exports.locals = {
	"SearchUI": "SearchUI__SearchUI___27zk2",
	"SearchUIDarkTheme": "SearchUI__SearchUIDarkTheme___uyV0K",
	"SearchUIDocked": "SearchUI__SearchUIDocked___3jLXq"
};
module.exports = exports;
